import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { switchMap, tap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { EntityState, EntityStore, QueryEntity } from '@datorama/akita';
import Apiable from '@core/state/jsonentity/interfaces/apiable';

@Injectable({providedIn: 'root'})
export class RelationConfigService<S extends EntityState = any> implements Apiable {
  protected filterType = 'RELATION';

  constructor(
    private _store: EntityStore<S>,
    private _query: QueryEntity<S>,
    private _apiService: ApiService,
  ) {

  }

  private apiCall() {
    return this._apiService.get('configurations?filter[type]=' + this.filterType).pipe(
      tap(data => {
        this._store.set(data['data']);
      })
    );
  }

  get() {
    const apiCall = this.apiCall();

    const hasContents = true; // this._query.getCount();

    if (!hasContents) {
      return apiCall;
    } else {
      // This is cached for a day or something specified in the store.
      return this._query.selectHasCache().pipe(
        switchMap(hasCache => {
          return (hasCache) ? EMPTY : apiCall;
        })
      );
    }
  }

  invalidateCache() {
    const apiCall = this.apiCall();
    return apiCall;
  }

  getPage(page = 1, params = {}) {
    // TODO:
    return of({});
  }
}
